import React from "react";
import { Whisper, Tooltip } from "rsuite";
import { addressFormat } from "../../utils/WalletUtils";
import { useTranslation } from "react-i18next";
import { useCopyAddress } from "../../hooks/copyAddress";

const Address = (props) => {
  const { address, className, isCopy, formatter } = props;
  const { t } = useTranslation();
  const [copyText, CopyContactAddress] = useCopyAddress();

  return (
    <Whisper
      placement="autoVertical"
      enterable
      triggers={["hover", "focus"]}
      speaker={<Tooltip>{address}</Tooltip>}
    >
      <div className={`${className}`}>
        <p>{formatter ? formatter(address) : addressFormat(address)}</p>
        {isCopy && (
          <i
            onClick={() => CopyContactAddress(address)}
            className={
              copyText === address
                ? "fa fa-clone tooltip3 active"
                : "fa fa-clone tooltip3"
            }
          >
            <div className="tooltiptext3">
              <p>{t("Copied")}</p>
            </div>
          </i>
        )}
      </div>
    </Whisper>
  );
};
export default React.memo(Address);
